<script>
import ModalWrapperChoice from "@/components/modals/ModalWrapperChoice";

export default {
  name: "ArmageddonModal",
  components: {
    ModalWrapperChoice
  },
  data() {
    return {
      isDoomed: false,
      remnantsGain: 0,
      realityShardGain: new Decimal(0),
      nextRealityShardGain: new Decimal(0),
      canArmageddon: false,
    };
  },
  computed: {
    topLabel() {
      if (!this.isDoomed) return `Вы собираетесь Обречь вашу Реальность`;
      return `Вы собираетесь совершить сброс Армагеддон`;
    },
    message() {
      const isFirstReset = (Currency.remnants.eq(0))
        ? `который произведёт ${format(this.nextRealityShardGain, 2, 2)} Осколков Реальности/сек`
        : `который увеличит ваш заработок Осколков Реальности с ${format(this.realityShardGain, 2, 2)}/сек
          до ${format(this.nextRealityShardGain, 2, 2)}/сек`;

      return `Армагеддон начнёт новую Обречённую Реальность. Вы заработаете
      ${ruQuantify("Остаток,Остатка,Остатков", this.remnantsGain, 2, 0)} ${isFirstReset}`;
    }
  },
  methods: {
    update() {
      this.isDoomed = Pelle.isDoomed;
      this.remnantsGain = Pelle.remnantsGain;
      this.realityShardGain.copyFrom(Pelle.realityShardGainPerSecond);
      this.nextRealityShardGain.copyFrom(Pelle.nextRealityShardGain);
      this.canArmageddon = Pelle.canArmageddon;
    },
    handleYesClick() {
      Pelle.initializeRun();
    },
  },
};
</script>

<template>
  <ModalWrapperChoice
    :option="isDoomed ? 'armageddon' : undefined"
    @confirm="handleYesClick"
  >
    <template #header>
      {{ topLabel }}
    </template>
    <div
      v-if="!isDoomed"
      class="c-modal-message__text"
    >
      Обречение вашей Реальности сбросит всё, за исключением рекордов Челленджей, прогресса Божеств и всего под
      заголовком Основное и Реальность на вкладке Статистики. Вы не получите никаких наград с текущего прогресса
      в вашей текущей Реальности. Обречение вашей Реальности также Очистит большую часть ваших незащищенных Глифов и
      отключит некоторые игровые механики.
      <br>
      <br>
      Вы уверены что хотите это сделать?
    </div>
    <div
      v-else
      class="c-modal-message__text"
    >
      {{ message }}
    </div>
  </ModalWrapperChoice>
</template>
